import '../../styles/Table.css';
import '../../styles/main.css';
import '../../styles/JustificationPage.css'
import { useMemo, useState } from 'react'


const coloredValue = (value) => {

	const result = Number(value);

	if (result > 0) {
	  return <span className="text-green-500">{result.toLocaleString('pt-BR')}</span>;
	}

	if (result < 0) {
	  return <span className="text-red-500">{result.toLocaleString('pt-BR')}</span>;
	}

	return <span className="text-gray-500">--</span>;
};

export default function ComparisionTableCIC({ tableData }) {

	const [ textFilter,  setTextFilter  ] = useState('')
	const [ deltaFilter, setDeltaFilter ] = useState('todos') // 'todos' | 'positivo' | 'negativo'

	const filteredTableData = useMemo(() => {

		if (!Array.isArray(tableData)) return tableData

		let result = tableData

		// filtro de texto, múltiplos termos separados por ';'
		const terms = textFilter
			.split(';')
			.map((term) => term.trim().toLowerCase())
			.filter(Boolean)

		if (terms.length > 0) {

			result = result.filter((data) => {

				const searchableText = [
					data.terminalname,
					data.railroadname,
					data.productname,
					data.justification,
				].filter(Boolean).join(' ').toLowerCase()

				return terms.every((term) => searchableText.includes(term))

			})

		}

		// filtro de positivo/negativo
		if (deltaFilter !== 'todos') {

			result = result.filter((data) => {

				const quantity = Number(data.quantityJustificated)

				if (deltaFilter === 'positivo') return quantity > 0
				if (deltaFilter === 'negativo') return quantity < 0

				return true

			})

		}

		return result

	}, [ tableData, textFilter, deltaFilter ])

	const totals = useMemo(() => {

		if (!Array.isArray(filteredTableData)) return { quantityJustificated: 0 }

		return filteredTableData.reduce((acc, data) => {

			acc.quantityJustificated += Number(data.quantityJustificated) || 0

			return acc

		}, { quantityJustificated: 0 })

	}, [filteredTableData])

    return (<>

			<div className="flex justify-between items-center flex-wrap gap-2 py-2">

				<div className="flex items-center gap-3 flex-wrap">

					<input
						type="text"
						value={textFilter}
						onChange={(e) => setTextFilter(e.target.value)}
						placeholder="Filtrar (separe vários termos com ;)"
						className="border rounded-[8px] px-3 py-1 text-sm w-[320px] max-w-full"
					/>

					<div className="flex items-center rounded-[8px] overflow-hidden border">

						<button
							type="button"
							onClick={() => setDeltaFilter('todos')}
							className={`px-3 py-1 text-sm ${deltaFilter === 'todos' ? 'bg-gray-300 text-gray-800' : 'bg-white text-gray-500'}`}
						>
							Todos
						</button>

						<button
							type="button"
							onClick={() => setDeltaFilter('positivo')}
							className={`px-3 py-1 text-sm ${deltaFilter === 'positivo' ? 'bg-[#6bf76b70] text-[#06aa06]' : 'bg-white text-gray-500'}`}
						>
							Positivo
						</button>

						<button
							type="button"
							onClick={() => setDeltaFilter('negativo')}
							className={`px-3 py-1 text-sm ${deltaFilter === 'negativo' ? 'bg-[#f76bc370] text-[#AA0657]' : 'bg-white text-gray-500'}`}
						>
							Negativo
						</button>

					</div>

				</div>

				<span className="text-sm text-gray-500 italic">
					{JSON.stringify(filteredTableData.length)} comparações.
				</span>

			</div>

    <table className="tables table-pattern-sistem w-full borda-cinza">
                    
                    <thead className="bg-neutro">
                        
                        <tr>
    
                            <th></th>
                            <th>Terminal</th>
                            <th>Ferrovia</th>
                            <th>Produto</th>
                            <th className="!text-right"><span>Δ</span></th>
                            <th className="!text-center">Justificativa</th>
                            <th></th>
                            
                        </tr>
                        
                    </thead>
                    
                    <tbody>
                        
                        {Array.isArray(filteredTableData) && filteredTableData.map((data, index) => (
                            
                            <tr key={data.id}>
    
                                <td  className="cursor-default">{String(index + 1).padStart(2, '0')}</td>
                                

                                <td>{data.terminalname}  </td>
                                <td>{data.railroadname}   </td>
                                <td>{data.productname}   </td>
                                
                                <td className="text-right px-4">  {coloredValue(data.quantityJustificated)}  </td>
                                <td className="text-left pl-5">  {data.justification} </td>

                            </tr>
                        ))}
                    </tbody>

					<tfoot>

						<tr className=" bg-neutro border-t border-[#e3e2e2]">

							<td colSpan={4} className="text-left px-5 py-2">Total</td>

							<td className="text-right px-4">{coloredValue(totals.quantityJustificated)}</td>

							<td></td>
							<td></td>

						</tr>

					</tfoot>
    
                </table>
    
    </>)

}